module.exports = __webpack_public_path__ + "img/71.d08538b5.jpg";